import gql from "graphql-tag";

export const GET_CONTACT_LIST = gql`
    query ContactList($contactListId: ID!){
        contactList(contactListId: $contactListId) {
            contactListId
            userId
            shareCategoryType
            shareCategoryId
            contactListName
            contactListDescription
            contactListType
            createdAt
            updatedAt
            deleted
            deletedAt
        }
    }
`;

export const GET_CONTACT_LISTS = gql`
    query ContactLists($searchStr: String, $limit: Int, $offset: Int, $showDeleted: Boolean, $orderList: [String]){
        contactLists(searchStr: $searchStr, limit: $limit, offset: $offset, showDeleted: $showDeleted, orderList: $orderList) {
            contactListId
            userId
            shareCategoryType
            shareCategoryId
            contactListName
            contactListDescription
            contactListType
            createdAt
            updatedAt
            deleted
            deletedAt
            memberCount
        }
    }
`;

export const GET_CONTACT_LIST_CONTACTS = gql`
    query ContactListContacts($contactListId: ID!, $searchStr: String, $limit: Int, $offset: Int, $showDeleted: Boolean, $orderList: [String]){
        contactListContacts(contactListId: $contactListId, searchStr: $searchStr, limit: $limit, offset: $offset, showDeleted: $showDeleted, orderList: $orderList) {
            contactListId
            userId
            contactListName
            contactListType
            contacts {
                contactId
                contactSalutation
                contactFirstName
                contactMiddleName
                contactLastName
                contactSuffix
                contactNickName
                displayName
                contactDescription
                contactLinkedinId
                tags {
                    tag
                }
            }
        }
    }
`;

export const GET_CONTACT_LISTS_OF_SHARE = gql`
    query ContactListsOfShare($shareCategoryType: String!, $shareCategoryId: ID!, $searchStr: String, $limit: Int, $offset: Int, $showDeleted: Boolean, $orderList: [String]){
        contactListsOfShare(shareCategoryType: $shareCategoryType, shareCategoryId: $shareCategoryId, searchStr: $searchStr, limit: $limit, offset: $offset, showDeleted: $showDeleted, orderList: $orderList) {
            contactListId
            userId
            shareCategoryType
            shareCategoryId
            contactListName
            contactListDescription
            contactListType
            createdAt
            updatedAt
            deleted
            deletedAt
            memberCount
        }
    }
`;

export const CREATE_CONTACT_LIST = gql`
    mutation CreateContactList($newContactList: newContactList!) {
        createContactList(
            newContactList: $newContactList
        ) {
            returnCode
            message
            id
            name
        }
    }
`;

export const UPDATE_CONTACT_LIST = gql`
    mutation UpdateContactList($changedContactList: changedContactList!) {
        updateContactList(
            changedContactList: $changedContactList
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_CONTACT_LIST = gql`
    mutation DeleteContactList($deleteContactListId: ID!) {
        deleteContactList(
            deleteContactListId: $deleteContactListId
        ) {
            returnCode
            message
        }
    }
`;

export const ADD_CONTACTS_TO_CONTACT_LISTS = gql`
    mutation AddContactsToContactLists($contactIdList: [ID!]!, $contactListIdList: [ID!]!) {
        addContactsToContactLists(
            contactIdList: $contactIdList
            contactListIdList: $contactListIdList
        ) {
            returnCode
            message
        }
    }
`;

export const REMOVE_CONTACTS_FROM_CONTACT_LISTS = gql`
    mutation RemoveContactsFromContactLists($contactIdList: [ID!]!, $contactListIdList: [ID!]!) {
        removeContactsFromContactLists(
            contactIdList: $contactIdList
            contactListIdList: $contactListIdList
        ) {
            returnCode
            message
        }
    }
`;
